export const EmptyDialCodeOption = {
  dialCode: '',
  name: '',
  iso2: '',
};
